import { render, staticRenderFns } from "./JSZlxg.vue?vue&type=template&id=6dc56704&scoped=true"
import script from "./JSZlxg.vue?vue&type=script&lang=js"
export * from "./JSZlxg.vue?vue&type=script&lang=js"
import style0 from "./JSZlxg.vue?vue&type=style&index=0&id=6dc56704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc56704",
  null
  
)

export default component.exports